import { render, staticRenderFns } from "./effectAnalysis.vue?vue&type=template&id=1564f525&scoped=true&"
import script from "./effectAnalysis.vue?vue&type=script&lang=js&"
export * from "./effectAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./effectAnalysis.vue?vue&type=style&index=0&id=1564f525&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1564f525",
  null
  
)

component.options.__file = "effectAnalysis.vue"
export default component.exports